import React from "react";
import { useTheme } from "@/lib/theme";
import { Sun, Moon, Monitor } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export const ThemeToggle = () => {
  const { theme, resolved, setTheme } = useTheme();
  const Icon = resolved === "dark" ? Moon : Sun;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          aria-label="Toggle theme"
          data-testid="theme-toggle-button"
          className="inline-flex items-center justify-center h-10 w-10 rounded-full border border-border text-foreground hover:bg-[hsl(var(--surface-tint))] focus-ring transition-colors"
        >
          <Icon className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem]">
        <DropdownMenuItem data-testid="theme-option-light" onClick={() => setTheme("light")} className={theme === "light" ? "font-semibold" : ""}><Sun className="h-4 w-4 mr-2" /> Light</DropdownMenuItem>
        <DropdownMenuItem data-testid="theme-option-dark" onClick={() => setTheme("dark")} className={theme === "dark" ? "font-semibold" : ""}><Moon className="h-4 w-4 mr-2" /> Dark</DropdownMenuItem>
        <DropdownMenuItem data-testid="theme-option-system" onClick={() => setTheme("system")} className={theme === "system" ? "font-semibold" : ""}><Monitor className="h-4 w-4 mr-2" /> System</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
